export default {
  clearSavedState() {
    localStorage.removeItem('admin_share_templates'); // MLD-6444
    localStorage.removeItem('subscribers');
    localStorage.removeItem('team_dashboard');
    localStorage.removeItem('team_groups');
    localStorage.removeItem('team_labels');
    localStorage.removeItem('team_presentations');
    localStorage.removeItem('team_shared_links');
    localStorage.removeItem('team_users');
  },
}
